import * as l from '../lib/littlejs.esm.js';
import { vec2 } from '../lib/littlejs.esm.js';
import Globals from './globals.ts';
export default class Camera {
    constructor() {
        this.pos = vec2(0, 0);
        this.scale = 32;
        this.zoom = 0;
        this.target = null;
        this.isTweening = false;
        this.tweenTargetPos = vec2(0, 0);
        this.tweenProgress = 0;
        this.tweenDuration = 1;
        this.edgeMarginPx = 24;
        this.scrollSpeedWps = 10;
        this.scaleRex = 32;
        this.scaleChip = 128;
        this.zoomStep = (this.scaleChip - this.scaleRex) / (this.tweenDuration * 60);
    }
    init(initialPos, initialTarget) {
        this.pos = initialPos.copy();
        this.scale = this.scaleRex;
        this.target = initialTarget;
        this.isTweening = false; // Ensure no tweening is active
        this.zoom = 0; // Ensure no zoom is active
        // @TODO - Calculate the scale so that the map fills the screen
        // If we don't set a scale and it calculates auto it works, so I can do that and just do 4x for Chip
        l.setCameraScale(this.scale);
        l.setCameraPos(this.pos);
    }
    setTarget(newTarget, zoomIn) {
        this.zoom = zoomIn ? this.zoomStep : -this.zoomStep;
        this.target = newTarget;
        // Start tweening
        this.tweenTargetPos = this.target.pos.copy();
        this.tweenProgress = 0;
        this.isTweening = true;
    }
    update() {
        // Check if game is in levelStart state - if so, don't update camera
        if (Globals.gameState === 'levelStart') {
            return;
        }
        // Update camera zoom gradually
        if (this.zoom !== 0) {
            this.scale += this.zoom;
            const roundedScale = Math.round(this.scale);
            if (roundedScale === this.scaleChip || roundedScale === this.scaleRex) {
                this.zoom = 0;
                this.scale = roundedScale;
            }
            l.setCameraScale(this.scale);
        }
        // Handle tweening
        if (this.isTweening) {
            this.tweenProgress += l.timeDelta / this.tweenDuration;
            this.tweenTargetPos = this.target?.pos.copy() || vec2(0, 0);
            if (this.tweenProgress >= 1) {
                this.tweenProgress = 1;
                this.isTweening = false;
                this.pos = this.tweenTargetPos.copy();
            }
            else {
                this.pos = this.pos.lerp(this.tweenTargetPos, this.tweenProgress);
            }
        }
        else {
            // Follow target
            if (this.target?.pos) {
                this.pos.x = this.target.pos.x;
                this.pos.y = this.target.pos.y;
            }
        }
        // Edge scrolling (commented out in original)
        // const mouse = l.mousePosScreen;
        // const screen = l.mainCanvasSize;
        // let dx = 0;
        // let dy = 0;
        // if (mouse.x <= this.edgeMarginPx) dx -= 1;
        // else if (mouse.x >= screen.x - this.edgeMarginPx) dx += 1;
        // if (mouse.y <= this.edgeMarginPx) dy += 1;
        // else if (mouse.y >= screen.y - this.edgeMarginPx) dy -= 1;
        // if (dx || dy) {
        //   const len = Math.hypot(dx, dy) || 1;
        //   dx /= len; dy /= len;
        //   this.pos = vec2(
        //     this.pos.x + dx * this.scrollSpeedWps * l.timeDelta,
        //     this.pos.y + dy * this.scrollSpeedWps * l.timeDelta,
        //   );
        // }
        // Clamp camera (commented out)
        // const view = l.getCameraSize();
        // const halfW = view.x * 0.5;
        // const halfH = view.y * 0.5;
        // const minX = halfW;
        // const maxX = Math.max(halfW, mapWidth - halfW);
        // const minY = halfH;
        // const maxY = Math.max(halfH, mapHeight - halfH);
        // this.pos = vec2(
        //   Math.min(maxX, Math.max(minX, this.pos.x)),
        //   Math.min(maxY, Math.max(minY, this.pos.y)),
        // );
        l.setCameraPos(this.pos);
    }
}
